export default "__VITE_ASSET__BKNbJ0eO__"